<template>
  <div class="relative">
    <div class="month-select-element font-primary font-medium text-sm text-primary flex items-center"
        @click="dropdownOpened = !dropdownOpened"
    >
     {{ title }}
      <svg class="ml-2" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.99987 6.58599L8.47487 4.11099L9.18187 4.81799L5.99987 7.99999L2.81787 4.81799L3.52487 4.11099L5.99987 6.58599Z" fill="#2D3748"/>
      </svg>
    </div>
    <div v-if="dropdownOpened" class="absolute bg-light  p-4">
      <div class="dropdown-option  py-1 px-6" v-for="option in options" :value="option.value" @click="toggleCchoice(option.value)">
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: String, 
    options: Array 
  },

  data() {
    return {
      dropdownOpened: false,
    };
  },

  methods: {
    toggleCchoice(n) {
      this.dropdownOpened = false;

      this.$emit('toggle-choice', n);
    }
  }
};
</script>

<style lang="scss">
.month-select-element {
  position: relative;
  z-index: 1000000;

  &:hover {
    cursor: pointer;
  }
}

.dropdown-option {
  &:hover {
    @apply underline;
    cursor: pointer;
  }
}
</style>
